<template>
  <building-blank-form
    submit-label="Сохранить"
    v-bind="$attrs"
    form-type="edit"
    :errors="errors"
    @submit="processBuildingForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { updateBuilding } from '@/services/building.service'
import buildingBlankForm from '@/components/forms/building/BuildingBlankForm'

export default {
  name: 'building-edit-form',
  components: { buildingBlankForm },
  inheritAttrs: false,
  data () {
    return {
      errors: {
        building: {
          id: [],
          number: [],
          contract_number_prefixes: [],
          address: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,

    processBuildingForm () {
      this.updateBuilding().then((success) => {
        if (success) {
          this.showMsg('Информация о доме была успешно обновлена!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    updateBuilding () {
      return updateBuilding(this.$attrs.building).then((response) => {
        this.fillErrors(this.errors.building, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.building, err.response.data)

        if (this.errors.non_field_errors[0]) {
          this.$parent.$parent.showPopupMsg(this.errors.non_field_errors[0], 'error')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BuildingEditForm.vue?787cf668